import _includes from 'lodash/includes';
import {SPECIAL_VIEW_BY_TYPES} from '../analytics.constants';
import {DimensionValue} from '../analytics.types';

export default function isUniqueDimensionValue(dimension: DimensionValue): boolean {
  return _includes(SPECIAL_VIEW_BY_TYPES, dimension);
}
